import { render, staticRenderFns } from "./Cornerstone.vue?vue&type=template&id=a3a45bd0&scoped=true"
import script from "./Cornerstone.vue?vue&type=script&lang=js"
export * from "./Cornerstone.vue?vue&type=script&lang=js"
import style0 from "./Cornerstone.vue?vue&type=style&index=0&id=a3a45bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a45bd0",
  null
  
)

export default component.exports